"use client"

import React from 'react';
import { motion, useScroll } from "framer-motion";

function ScrollIndicator() {
  const { scrollYProgress } = useScroll();

  return (
    <motion.div
      style={{
        scaleX: scrollYProgress,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 100,
        transformOrigin: "0%",
        backgroundColor: "var(--color-vino)",
      }}
    />
  );
}

export default ScrollIndicator;